/* eslint-disable quotes */
/** @typedef {import('headlight-configurable-application').Pict} Pict */
/** @typedef {import('headlight-configurable-application').Fable} Fable */

const libPictLeafletView = require('pict-section-leaflet');

class GeolocationSelector extends libPictLeafletView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict = pFable;
		/** @type {Fable} */
		this.fable = pFable;
		/** @type {import('leaflet').Map} */
		this.leaflet = null;
		/** @type {any} */
		this.options;
		/** @type {string} */
		this.rawHTMLID;
	}

	/**
	 * Returns the HTML ID for the map based on the input HTML ID.
	 * @param {string} pInputHTMLID - The HTML ID of the input.
	 * @return {string} - The HTML ID for the map.
	 */
	getMapHTMLID(pInputHTMLID)
	{
		return `MAP-FOR-${pInputHTMLID}`;
	}

	getInitialMapLocation()
	{
		let tmpLocation = null;
		if (this.pict.AppData?.DocumentData?.ReportData?.Project?.Latitude && this.pict.AppData?.DocumentData?.ReportData?.Project?.Longitude)
		{
			const tmpLat = Number(this.pict.AppData.DocumentData.ReportData.Project.Latitude);
			const tmpLng = Number(this.pict.AppData.DocumentData.ReportData.Project.Longitude);
			tmpLocation = {
				lat: tmpLat,
				lng: tmpLng,
			};
		}
		return tmpLocation;
	}

	/**
	 * Called before the view is rendered.
	 * This method sets up options for leaflet initialization.
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onBeforeRender(pRenderable)
	{
		this.options.LeafletDestinationAddress = this.getMapHTMLID(this.rawHTMLID);
		const initialCenter = this.getInitialMapLocation();
		if (initialCenter)
		{
			//FIXME: need to remove state from the view (if it is shared)
			this.leafletInitialCenter = initialCenter;
		}
		// set the flag based on the input type
		//FIXME: need to address this now that the record is no longer plumbed in here
		//this.options.hideLeafletMap = pRecord.PictForm.InputType !== 'GeolocationSelectorWithMap';
		return super.onBeforeRender(pRenderable);
	}

	/**
	 * Called after the view is rendered.
	 * The method stores leaflet data after initialization for the provider to access
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable object that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		super.onAfterRender(pRenderable);
		if (!this.pict.AppData.LeafletMapsData)
		{
			this.pict.AppData.LeafletMapsData = {};
		}
		this.pict.AppData.LeafletMapsData[this.rawHTMLID] = {
			map: this.leaflet,
			RawHTMLID: this.rawHTMLID,
			destinationAddress: this.options.LeafletDestinationAddress,
			hideMap: this.options.hideLeafletMap,
			marker: null,
			location: {
				Latitude: '',
				Longitude: '',
			},
		};
	}

	/**
	 * Called after the Leaflet map is initialized.
	 * This method is responsible for loading the map tiles and setting up the initial view.
	 * @return {void}
	 */
	onAfterInitializeLeaflet()
	{
		// Load tiles
		const libLeaflet = window.L;
		// using this.leaflet only works here because this is called during super.onAfterRender
		// https tiles (avoids mixed-content when the report is served over https) + the canonical host.
		this.tileLayer = libLeaflet.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
		{
			maxZoom: 19,
			attribution: '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a>',
		}).addTo( this.leaflet );
	}
}

module.exports = GeolocationSelector;

module.exports.default_configuration =
{
	ViewIdentifier: "GeolocationSelector",
	DefaultRenderable: "GeolocationSelector",
	DefaultDestinationAddress: "#GeolocationSelector-Container",
	AutoRender: false,
	CSS: /*css*/``,
	Templates: [
		{
			Hash: "GeolocationSelector",
			Template: /*html*/`
			<div id="MAP-FOR-{~D:Record.Macro.RawHTMLID~}" style="min-height: 320px; z-index: 1;"></div>
			`,
		},
	],
	Renderables: [
		{
			RenderableHash: "GeolocationSelector",
			TemplateHash: "GeolocationSelector",
			DestinationAddress: "#GeolocationSelector-Container",
		},
	],
};
